<template lang="pug">
base-layout
</template>


<script>
import BaseLayout from '@/layouts/base'

export default {
  components: { BaseLayout },
}
</script>
